<template>
	<Modal @close="closeModal" v-if="CustomersWithNoRecentSalesModalShow">
		<template slot="title">Customers With No Recent Sales</template>
		<template slot="body">
			<div class="list_top_box" style="width: 800px;">
				<div class="left_option">
					<em class="lt_text">Invoice Date</em>
					<span class="mgr_5"> <CustomDatePicker v-model="from_date" /> ~ <CustomDatePicker v-model="to_date" /> </span>
					<input type="button" class="search_bt" @click="search()" value="Search" />
					<span v-if="list.length > 0" class="int_type_no_border fl_r mgl_15">Count : {{ list.length | commaSeparated }}</span>
				</div>
			</div>
			<div class="view_inner">
				<div class="fixed-table-container" style="height:670px;">
					<div class="table-wrapper">
						<table id="item_list" class="list_tbl tbl_pointer">
							<thead>
								<tr>
									<th style="text-align:center;width:5%;">
										<div class="th-text">
											Code
										</div>
									</th>
									<th style="text-align:center;width:15%;">
										<div class="th-text">
											Name
										</div>
									</th>
								</tr>
							</thead>

							<tbody>
								<tr v-for="partner in list" v-bind:key="partner.code">
									<td>{{ partner.code }}</td>
									<td class="truncate">{{ partner.name }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="view_bottom_bt">
					<input type="button" value="Make In-Active" class="search_bt mgr_15" @click="submit" />
					<a href="javascript:void(0);" type="button" class="gray_bt" @click="closeModal">Cancel</a>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/common/Modal';
import { mapState } from 'vuex';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { apiCustomersWithOutInvoices, apiPartnerNotActive } from '@/api/partner';
import { daysAgo, today } from '@/utils/date';

export default {
	name: 'CustomersWithoutInvoices',
	data() {
		return {
			from_date: daysAgo(1095),
			to_date: today(),
			list: [],
		};
	},
	components: { Modal, CustomDatePicker },
	computed: {
		...mapState({
			CustomersWithNoRecentSalesModalShow: state => state.partners.CustomersWithNoRecentSalesModalShow,
		}),
		param() {
			return {
				from_date: this.from_date,
				to_date: this.to_date,
			};
		},
	},
	methods: {
		closeModal() {
			this.$store.dispatch('partners/AC_CustomersWithNoRecentSalesModalShow', false);
		},
		search() {
			apiCustomersWithOutInvoices(this.param).then(res => {
				this.list = res.data;
			});
		},
		update(param) {
			apiPartnerNotActive(param)
				.then(res => {
					this.$toast.success(res.data);
					this.closeModal();
				})
				.catch(err => {
					this.$toast.error(err.data);
				});
		},
		submit() {
			const codes = this.list.map(partner => {
				return partner.code;
			});
			if (codes.length > 0) {
				const param = { partner_codes: codes };
				this.$alertify.confirm(`Change ${this.list.length} partners to not active state? `, () => {
					this.update(param);
					this.list = [];
				});
			} else {
				this.$toast.error('No data to update');
			}
		},
	},
};
</script>

<style scoped></style>
